<template>
  <div id="newAdd">
  <el-dialog
    title="新增"
    :visible.sync="drawer"
    width="640px"
    :close-on-click-modal='false'>
    <div class="page2" style="overflow-y: auto;max-height: 720px;">
      <h3>产品信息</h3>
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="160px" class="demo-ruleForm">
        <div v-for="(item,index) in orderProduct" v-show=" item.isChecked == 1" style="display: flex;">
          <div class="titleLable">
            <span style="color: #F56C6C;">
              *
            </span>
            {{item.fieldname}}
          </div>
          <el-input placeholder="请输入内容" v-model="addField[index]" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" clearable style="width: 425px;" size="small"></el-input>
        </div>
        <h3 v-show="keyArray2.length > 0">价格信息</h3>
        <el-form-item :label="item.fieldname" v-for="(item,index) in orderPrice" v-show="item.fieldRequired != 1 && item.isChecked == 1">
          <el-input-number
            :min="0"
            :precision="2"
            :controls="false"
            v-model="addField2[index]"
            type="number"
            style="width: 425px;"
            placeholder="请输入"
            size="small"
            onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            clearable
            >
         </el-input-number>
        </el-form-item>
        <h3 v-show="keyArray3.length > 0">备注信息</h3>
        <el-form-item :label="item.fieldname" styel="width: 425px;" v-for="(item,index) in orderMemo" v-show="item.isChecked == 1">
          <el-input
            placeholder="请输入内容"
            v-model="addField3[index]"
            style="width: 425px;" size="small"
            onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            clearable
            v-if="item.fieldvalue != 'product_pic'" >
          </el-input>
          <el-upload
            v-else
            class="avatar-uploader"
            action="/hcm/iprScreenshot/headUpload"
            :show-file-list="false"
            :before-upload="handleBeforeUpload"
            :on-success="(res)=>{handleUploadSuccess(index,res)}"
            accept="image/png, image/jpg"
            ref="elUpload"
            style="margin-bottom: 25px;">
            <img v-if="addField3[index]" :src="addField3[index]" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" style="margin-left: 100px;" @click="submitForm('ruleForm')" size="small">确 定</el-button>
      <el-button @click="jump()" type="TheCustom" size="small" style="margin-left: 16px;">取 消</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
  import aes from "../../libs/aes";
  export default {
    name: "newAdd",
    data() {
      return {
        productClassifyId: '',
        ruleForm: {
          brandName: '',
          productName: '',
        },
        drawer: false,
        textarea: '',
        addField: [],
        addField2: [],
        addField3: [],
        orderMemo: [],
        orderPrice: [],
        orderProduct: [],
        allorder: [],
        tableData: [],
        keyArray: [],
        keyArray2: [],
        keyArray3: [],
        submitArray: {},
        submitArray2: {},
        submitArray3: {},
        fieldnameVersion: false,
        brandVersion: false,
        rules: {
          productName: [
            { required: true, message: '请输入', trigger: 'blur' },
          ],
        },
        imageUrl: '',
      }
    },
    methods: {
      handleBeforeUpload(file) {
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!isLt20M) {
          this.$message.error('上传文件大小不能超过 20MB!');
        }
        return isLt20M;
      },
      handleUploadSuccess(index,res) {
        this.addField3[index] = res.data.data
        this.$forceUpdate()
        console.log(this.addField3[index])
        if (this.imageUrl) {
          this.$notify({
            title: '成功',
            message: '上传成功',
            type: 'success'
          });
        }
      },
      newAddChildShow() {
        this.drawer = true
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            for (var i = 0; i < this.keyArray.length; i++) {
              if (this.addField[i] == '' || !this.addField[i]) {
                this.$message.error('请填写完整的产品信息')
                return;
              } else {
                this.submitArray[this.keyArray[i]] = this.addField[i]
              }
            }
            this.ruleForm.productName = this.submitArray.product_name
            // delete this.submitArray.brand_name;
            delete this.submitArray.product_name;
            for (var i = 0; i < this.keyArray2.length; i++) {
              if (this.addField2[i] || this.addField2[i] == 0) {
                this.submitArray2[this.keyArray2[i]] = this.addField2[i].toFixed(2)
              }
            }
            for (var i = 0; i < this.keyArray3.length; i++) {
              this.submitArray3[this.keyArray3[i]] = this.addField3[i]
            }
            Object.assign(this.submitArray,this.submitArray2,this.submitArray3)
            console.log(this.ruleForm.productName)
            let params={
              bmcid : '',
              brandName : this.ruleForm.brandName.replace(/\s/g, ""),
              // productName : this.ruleForm.productName.replace(/\s/g, ""),
              productClassifyId: this.productClassifyId,
              addField: JSON.stringify(this.submitArray),
              id : ''
            }
            if (this.ruleForm.productName) {
              params.productName = this.ruleForm.productName.replace(/\s/g, "")
            }
            fetch({
              url: "hcm/hcmProduct/save",
              method: "post",
              params: params,
              noFormat: true,
              responseType: "text"
            }).then(result => {
              let res = JSON.parse(result);
              let {data}=res
              if(res.status == '10000'){
                this.$message({
                  showClose: true,
                  message: '新增成功',
                  type: 'success'
                });
                this.keyArray = [];
                this.keyArray2 = [];
                this.drawer = false
                this.$emit('theQueryParams',this.productClassifyId)
                this.addField = [];
                this.addField2 = [];
                this.addField3 = [];

              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'warning'
                });
              }
            })
          } else {
            return false;
          }
        });
      },
      getOrder(e) {
        console.log(e)
        this.productClassifyId = e
        let params={
          productClassifyid: e
        }
        fetch({
          url: "hcm/hcmCustomModel/getByProduct",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.keyArray = [];
            this.keyArray2 = [];
            this.keyArray3 = [];
            this.orderMemo = data.memo.data;
            this.orderPrice = data.price.data;
            this.orderProduct = data.product.data;
            var newarry = [];
            var newarry2 = [];
            // var arrv = [];
            newarry = this.orderPrice.concat(this.orderProduct);
            newarry2 = this.orderMemo.concat(newarry);
            this.compare();
            newarry2.sort(this.compare('sort'));
            this.allorder = newarry2;
            for (var i = 0; i < this.orderProduct.length; i++) {
              if (this.orderProduct[i].isChecked == 1) {
                this.keyArray.push(this.orderProduct[i].fieldvalue)
              }
            }
            for (var i = 0; i < this.orderPrice.length; i++) {
              if (this.orderPrice[i].isChecked == 1) {
                this.keyArray2.push(this.orderPrice[i].fieldvalue)
              }
            }
            for (var i = 0; i < this.orderMemo.length; i++) {
              if (this.orderMemo[i].isChecked == 1) {
                this.keyArray3.push(this.orderMemo[i].fieldvalue)
              }
            }
          }
        })
        .catch(err => {

        })
      },
      //数组排序
      compare(property) {
        return function (a, b) {
          var value1 = a[property];
          var value2 = b[property];
          return value1 - value2;
        }
      },
      jump() {
        this.drawer = false
      }

    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }
  .page2 {
    background-color: white;
  }
  .titleLable {
    width: 165px;
    margin-bottom: 22px;
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
  
</style>
<style lang="scss">
  #newAdd{
    .el-dialog__body .el-form {
      padding: 0;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
    .el-input__icon {
      height: 32px;
      width: 25px;
      text-align: center;
      -webkit-transition: all .3s;
      transition: all .3s;
      line-height: 32px;
    }
    .el-input-number.is-without-controls .el-input__inner {
      text-align: left;
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }
</style>
